export default __webpack_public_path__ + "static/media/Cloak of Hugin.19f1d22d.jpg";